import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import React from 'react';

import FeatureIconCircle from '@/components/common/FeatureIconCircle';

import './HomeFeaturePreview.css';

/**
 * Wide, full-container feature row for the home page "Explore the Hub"
 * section. Icon on the left, text on the right, divider-separated, no card
 * chrome — every row reads the same way instead of alternating sides.
 */
export default function HomeFeaturePreview({
    title,
    description,
    ctaLabel,
    to,
    icon,
    iconFullColor,
    bootstrapIcon,
    iconVariant,
}) {
    return (
        <Link
            to={to}
            aria-label={title}
            className="home-feature-row d-block text-decoration-none text-reset"
        >
            <Row className="align-items-center g-4">
                <Col xs={12} md={3} className="d-flex justify-content-center">
                    <FeatureIconCircle
                        icon={icon}
                        bootstrapIcon={bootstrapIcon}
                        iconVariant={iconVariant}
                        fullColor={iconFullColor}
                        size="lg"
                    />
                </Col>
                <Col xs={12} md={9}>
                    <h3 className="fs-2 fw-bold text-primary">{title}</h3>
                    <p className="fs-5 text-muted mb-3">{description}</p>
                    <span className="home-feature-row-cta fw-semibold text-primary d-inline-flex align-items-center gap-1">
                        {ctaLabel}
                        <i className="bi bi-arrow-right" aria-hidden="true" />
                    </span>
                </Col>
            </Row>
        </Link>
    );
}

HomeFeaturePreview.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ctaLabel: PropTypes.string,
    to: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconFullColor: PropTypes.bool,
    bootstrapIcon: PropTypes.string,
    iconVariant: PropTypes.oneOf([
        'primary',
        'danger',
        'info',
        'secondary',
        'warning',
    ]).isRequired,
};

HomeFeaturePreview.defaultProps = {
    ctaLabel: 'Explore',
    icon: null,
    iconFullColor: false,
    bootstrapIcon: null,
};
